import { useDispatch, useSelector } from 'react-redux';
import { selectActNoteForCFE, selectIsEditNotesForCFE, setNotes } from '../../../../../../features/actuarial/remark-slice';
import { EditIconSVG } from '../../../../../../assets/icon/svg';
import RichTextViewer from '../../../../../../library/ckeditor/rich-text-viewer';
import { useComputationActions } from '../../../../../../hooks/actions/user-computation-actions';
import CKEditor from '../../../../../../library/ckeditor/ck-editor';

export default function ActNotesForCfe() {

    const dispatch = useDispatch();
    const noteForCFE = useSelector(selectActNoteForCFE);
    const isEditNotesForCFE = useSelector(selectIsEditNotesForCFE);
    const { 
        cantEdit,
        handleSaveNotesForCFE, 
        handleCancelSaveNotesForProposal, 
        handleIsEditNotesForProposal,
        isLoadingSaveNotesToCFE
    } = useComputationActions();

    return (
        <div className={`col-span-1 overflow-hidden rounded-lg border border-gray-300 grid grid-col-1`}>
            <div className="flex items-center justify-between gap-3 border-b border-gray-200 bg-gray-50 px-3 py-3 sm:px-4">
                <div className="min-w-0 flex-1">
                    <div className="flex items-center gap-2">
                        <span className="h-2 w-2 shrink-0 rounded-full bg-[#186cb2]" />
                        <h3 className="truncate text-xs font-semibold text-gray-800">
                            Notes for CFE
                        </h3>
                    </div>
                    <p className="mt-0.5 text-[10px] leading-4 text-gray-500 sm:text-[11px]">
                        Enter internal notes or instructions for the CFE team. These notes are for internal reference only.
                    </p>
                </div>
                <button
                    disabled={cantEdit}
                    onClick={() => handleIsEditNotesForProposal('cfe')}
                    className="flex size-9 shrink-0 items-center justify-center rounded-md border border-gray-300 bg-white text-[#186cb2] transition-colors hover:bg-[#186cb2]/5 disabled:cursor-not-allowed disabled:opacity-50 sm:h-auto sm:w-auto sm:gap-1.5 sm:px-3 sm:py-1.5"
                >
                    <EditIconSVG size={14} />
                    <span className="hidden sm:inline text-xs">Edit Notes</span>
                </button>
            </div>
            <div className="p-3">
                <RichTextViewer value={noteForCFE} />
            </div>
            <CKEditor
                isOpen={isEditNotesForCFE}
                title={'notes for CFE'}
                value={noteForCFE}
                onChange={(e) => dispatch(setNotes({ type: 'cfe', value: e}))}
                onClose={() => handleCancelSaveNotesForProposal('cfe')}
                onSave={handleSaveNotesForCFE}
                isLoading={isLoadingSaveNotesToCFE}
            />
        </div>
    )
}
